




























































import mixins from 'vue-typed-mixins'
import CommandeMixin from './CommandeMixin'

export default mixins(CommandeMixin).extend({
    data() {
        return {
            headers: this.isMobileDevice()
                ? [
                      { text: 'Code client', value: 'codeClient' },
                      { text: 'Inventoriste', value: 'nomUtilisateurCreateur' },
                      { text: '', value: 'action', align: 'end', sortable: false }
                  ]
                : [
                      { text: 'Code client', value: 'codeClient' },
                      { text: 'Inventoriste', value: 'nomUtilisateurCreateur' },
                      { text: 'Date de création', value: 'dateCreation' },
                      { text: '', value: 'action', align: 'end', sortable: false }
                  ]
        }
    },
    methods: {
        getCodeClientName(codeClient: number | string) {
            return this.companiesAutoComplete.find(x => x.value == codeClient)?.text || 'N/A'
        },
        formatDate(date: Date) {
            return new Date(date).toLocaleDateString('fr-FR')
        },
        reload() {
            this.initialize()
        }
    }
})
